import { post } from './api';

export function logOneOffEvent(eventKey) {
  post('/one_off_events', { eventKey });
}
